import React, { Component } from 'react';
import { connect } from 'react-redux';
import Util from '../../../util';
import { hashHistory } from 'react-router';
import { Toast } from 'antd-mobile/lib';
import NavigatorMain from '../../NavigatorMain';
import { getTempInfo } from '../../../common.js';
import {findCamcHqtExist,getCardByHqt, getCardByHqtOpen, getCardListByCf,htqAddCardNum} from '../../../action/myAssets/userInfoAction'
import {bankCode,protocolCode} from '../../../BankCode.js';


class HqtBindCard extends Component {
	constructor(props){
	  super(props);
	  this.state = {
	    cardNumber: this.props.location && this.props.location.state.bankAccountShowNo ? this.props.location.state.bankAccountShowNo : this.props.htqAddCardNum,
        agreeIcon: false,
        phoneNumber: this.props.location && this.props.location.state.mobileNo ? this.props.location.state.mobileNo : "",
	  }
	}
	goCertification = () => {
	  const { phoneNumber, cardNumber } = this.state;
	  const { paymentChannelId, bankAccountName, router, certType, certNo, bankCode, openHqt, callback, isShow, fundCode } = this.props.location.state;
	  let regPhone = /^1[0123456789]\d{9}$/;
	  if(!(regPhone.test(phoneNumber))){ 
	  	  Toast.show("手机号有误，请重新输入", 2);
	      return ; 
	  }

	  hashHistory.push({
	    pathname: "/HqtCheckCard",
	    state: {
	      paymentChannelId: paymentChannelId,
	      bankAccountShowNo: cardNumber,
	      mobileNo: phoneNumber,
	      bankAccountName: bankAccountName,
	      certType: certType,
	      certNo:certNo,
	      bankCode: bankCode,
	      router: router,
	      openHqt: openHqt,
	      callback: callback,
	      isShow: isShow,
	      fundCode: fundCode
	    }
	  })
	}

	changeCardNumber = (value) => {
	  this.setState({
	    cardNumber :value
	  })
	   this.props.dispatch(htqAddCardNum(value))
	}

	changePhoneNumber = (value) => {
	  this.setState({
	    phoneNumber :value
	  })
	}

	changeAgree = () => {
	  this.setState({
	    agreeIcon: this.state.agreeIcon ? false : true
	  })
	}
	
	handleJumpToProtocol(title){
	    let code = protocolCode[title];
	    hashHistory.push({
	        pathname:'/WebView',
	        state:{name:title,code:code},
	        query: {code:code}
	    })
	}
	goBack = () => {
	    hashHistory.goBack();
	}
	render() {
		let openHqt = this.props.location.state && this.props.location.state.openHqt;
		const { phoneNumber, cardNumber, agreeIcon } = this.state;
		let { htqAddCardNum } = this.props;
		console.log
		return (
			<div className="mainBox">
				<NavigatorMain>
					<div className="boxHeader">
					  <div>
					    <img onClick={this.goBack} src={require("../../../img/leftArrow_header.png")} />
					  </div>
					  <div>
					    <span>{ openHqt ? "开通活期通" : "添加银行卡" }</span>
					  </div>
					  <div>
					    
					 </div>
		          </div>
		        </NavigatorMain> 
				<div className="content">
					<div style={{paddingLeft: 13, paddingRight: 13, paddingTop: 20, paddingBottom: 10}}>
						<div style={{fontSize: "13px", color: "#5b6370"}}>请绑定您本人的银行卡</div>
					</div>
					<div style={styles.inputContainer}>
						<div style = {styles.centerItems}>
							<span  style={styles.leftText}>银行卡</span>
						</div>
						<div style = {styles.flexViewContainer}>
							<input
								style={styles.rightTextInput}
								value={this.state.cardNumber}
								onChange={(event)=>{ this.changeCardNumber(event.target.value) }}
								type="text"
								placeholder="请输入卡号"
							/>
						</div>
					</div>
					<div style={styles.inputContainer}>
						<div style = {styles.centerItems}>
							<span  style={styles.leftText}>手机号</span>
						</div>
						<div style = {styles.flexViewContainer}>
							<input
								type="text"
								style={styles.rightTextInput}
								value={phoneNumber}
								onChange={(event)=>{this.setState({phoneNumber:event.target.value})}}
								placeholder='请输入银行预留手机号'
							/>
						</div>
					</div>
	

				<div style={{display:"-webkit-flex", WebkitFlexDirection: "row", /*WebkitAlignItems: "center",*/ paddingRight: 13, paddingLeft: 13}}>
					<div onClick={this.changeAgree}>
						{
							agreeIcon ? <img style={{height: 44, width: 44, marginRight: 5, marginLeft: -8}} src={require('../../../img/squareHook.png')} /> :
							<img style={{height: 44, width: 44, marginRight: 5, marginLeft: -8}} src={require('../../../img/square.png')} />
						}
					</div>
					<div onClick={this.changeAgree} style={{paddingTop: 10, marginLeft: -5}}>
						<span  style={{color: "#5b6370", fontSize: 12, lineHeight: "20px",}}>我已阅读并同意<span  style = {{color: '#f8986a'}} onClick = {()=>{this.handleJumpToProtocol('上海华夏财富投资管理有限公司快易付业务协议')}}>《上海华夏财富投资管理有限公司快易付业务协议》</span></span>
					</div>
				</div>

				<div  style = {styles.touchHighlightBtn}  delayPressIn = {0} onClick = {cardNumber && phoneNumber && agreeIcon? ()=>{this.goCertification()} : null }>
				  <div style = {Object.assign(styles.nextStepBtn,{backgroundColor: cardNumber && phoneNumber && agreeIcon ? '#FE492E' : '#afb0b2'})}>
				    <span  style = {{color: '#ffffff', fontSize: 15}}>下一步</span>
				  </div>
				</div>
				<div style={{marginTop:20,paddingLeft:13,paddingRight:13}}>
			        <div style={{height:30,fontSize:12}}>温馨提示 :</div>
		            <div  style={{color:'rgba(130,138,138,1)',fontSize:12,lineHeight:"22px"}}>1、活期通是由华夏基金提供的理财产品，华夏财富将为您在华夏基金开立直销账户，并提供活期通充值业务；</div>
		            <div  style={{color:'rgba(130,138,138,1)',fontSize:12,lineHeight:"22px"}}>2、如需变更活期通对应的银行卡，您需分别登录华夏基金官网和华夏财富官网进行银行卡变更，您也可以致电客服热线400-817-5666咨询办理。</div>
				</div>
					
				</div>

	
			</div>
		)
	}
}

const styles = {
	centerItems: {
		display: "-webkit-flex",
	  WebkitFlexDirection: 'row',
	  WebkitJustifyContent: 'center',
	  WebkitAlignItems: 'center',
	},
	headerLeftView: {
	  marginTop: 20,
	  height: 44,
	},
	headerMiddleView: {
	  marginTop: 20,
	  height: 44,
	},
	headerRightView: {
	  marginTop: 20,
	  height: 44,
	},
	headerLeftContent: {
	  width: 44,
	},
	headerMiddleContent: {
	  fontSize: 13,
	  color: '#fff',
	  backgroundColor: 'transparent',
	},
	headerRightContent: {
	  width: 44,
	  fontSize: 13,
	  color: '#fff',
	  backgroundColor: 'transparent',
	},
	touchHighlightBtn: {
	  marginTop: 14,
	  marginLeft: 13,
	  marginRight: 13,
	  borderRadius: 20,
	},
	loginView: {
		display: "-webkit-flex",
	  backgroundColor: '#FE492E',
	  height: 40,
	  borderRadius: 20,
	  WebkitFlexDirection: 'row',
	  WebkitAlignItems: 'center',
	  WebkitJustifyContent: 'center',
	}, 
	inversedLoginView: {
	  display: "-webkit-flex",
	  backgroundColor: '#ffffff',
	  borderColor: '#fe492e',
	  borderStyle: "solid",
	  height: 40,
	  borderWidth: 1,
	  borderRadius: 20,
	  WebkitFlexDirection: 'row',
	  WebkitAlignItems: 'center',
	  WebkitJustifyContent: 'center',
	},
	rightArrow:{
	    marginRight: -2,
	    width: 44,
	    height: 44,
	},
	container: {
	 	display: "-webkit-flex",
	    height: 45,
	    borderBottom:'1px solid rgb(235, 238, 240)',
	    justifyContent: "space-between",
	    alignItems: "center",
	    flexDirection: "row",
	    paddingLeft: 13,
	    paddingRight: 5,
	    backgroundColor: "#fff"
   },
   	nextStepBtn: {
		display: "-webkit-flex",
	  backgroundColor: '#FE492E',
	  borderRadius: 20,
	  height: 40,
	  WebkitFlexDirection: 'row',
	  WebkitAlignItems: 'center',
	  WebkitJustifyContent: 'center',
	},
	inputContainer: {
		display: "-webkit-flex",
	    width: 'auto',
	    height: 45,
	    borderBottomColor: 'rgba(242,245,247,1)',
	    borderBottomWidth: 1,
	    borderBottomStyle: "solid",
	    backgroundColor: '#ffffff',
	    WebkitFlexDirection: 'row',
	    WebkitAlignItems: 'center',
	},
	centerItems: {
	  display: "-webkit-flex",
	  WebkitFlexDirection: 'row',
	  WebkitJustifyContent: 'center',
	  WebkitAlignItems: 'center',
	},
	leftText: {
	  color: '#3a3e47',
	  marginLeft: 13,
	  fontSize: 13,
	  width: 68,
	},
	flexViewContainer: {
	  display: "-webkit-flex",
	  WebkitFlex: 1,
	  WebkitFlexDirection: 'row',
	  WebkitAlignItems: 'center',
	},
};

function mapStateToProps(state,ownProps) {
  return {
	verifiedUserInfo: state.verifiedUserInfo,
    findHqtExist:state.findHqtExist,
    htqAddCardNum:state.htqAddCardNum
  }
}

export default connect(mapStateToProps)(HqtBindCard);


// WEBPACK FOOTER //
// ./src/components/myAssets/myCard/HqtBindCard.js